import apiClient from "./client.js";

// ----- Enrollment tokens -----
export async function fetchServerTokens() {
  const res = await apiClient.get("/server-tokens");
  return res.data.data;
}

export async function createServerToken(name) {
  const res = await apiClient.post("/server-tokens", { name });
  return res.data.data; // includes one-time `token`
}

export async function revokeServerToken(id) {
  const res = await apiClient.delete(`/server-tokens/${id}`);
  return res.data.data;
}

// ----- Servers -----
export async function fetchServers() {
  const res = await apiClient.get("/servers");
  return res.data.data;
}

export async function fetchServer(id) {
  const res = await apiClient.get(`/servers/${id}`);
  return res.data.data;
}

export async function updateServer(id, patch) {
  const res = await apiClient.patch(`/servers/${id}`, patch);
  return res.data.data;
}

export async function deleteServer(id) {
  await apiClient.delete(`/servers/${id}`);
}

export async function fetchServerMetrics(id, window = "24h") {
  const res = await apiClient.get(`/servers/${id}/metrics`, { params: { window } });
  return res.data.data;
}

// ----- Alert rules -----
export async function fetchServerAlertRules() {
  const res = await apiClient.get("/server-alert-rules");
  return res.data.data;
}

export async function createServerAlertRule(payload) {
  const res = await apiClient.post("/server-alert-rules", payload);
  return res.data.data;
}

export async function updateServerAlertRule(id, patch) {
  const res = await apiClient.patch(`/server-alert-rules/${id}`, patch);
  return res.data.data;
}

export async function deleteServerAlertRule(id) {
  await apiClient.delete(`/server-alert-rules/${id}`);
}
